

























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { SpecificationViewObject } from '@/types/apiServerContract';
import dictionaryService from '@/core/translation/dictionary.service';

import ReadMore from '@/core/ui-components/ReadMore.vue';

@Component({
    components: { ReadMore }
})
export default class ProductDetailsSpecifications extends Vue {
    @Prop({ required: true, type: Array })
    private specifications!: SpecificationViewObject[];

    public open() {
        this.$refs.readmore.open();
    }

    public close() {
        this.$refs.readmore.close();
    }

    getUnit(unit: string) {
        return dictionaryService.translate(unit);
    }

    public $refs!: {
        readmore: ReadMore;
    };
}
